import { render, staticRenderFns } from "./DataMapDomain.vue?vue&type=template&id=8b5a49ec&"
import script from "./DataMapDomain.vue?vue&type=script&lang=js&"
export * from "./DataMapDomain.vue?vue&type=script&lang=js&"
import style0 from "./DataMapDomain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports